module.exports = require("rxjs/operators/skip");


//////////////////
// WEBPACK FOOTER
// external "rxjs/operators/skip"
// module id = 878
// module chunks = 0